//!TODO: check if need here ot need to remove or move to main tools;
//!TODO: store and cache calculated values
//!TODO: need more light and smart version of this functon;
export const monthsForLocale = (
	localeName = window.navigator.language ?? "en-US",
	monthIndex: number,
	year: number,
	monthFormat: "long" | "numeric" | "2-digit" | "short" | "narrow" | undefined = "long",
) => {
	const format = new Intl.DateTimeFormat(localeName, { month: monthFormat }).format;
	return [...Array(12).keys()].map(_m => format(new Date(Date.UTC(year, monthIndex % 12))))[0];
};

export const randomSHA256 = async () => {
	const val = new Date().getTime().toString();
	const res = await hashValue(val);
	return res;
};

export const hashValue = async (val: string) =>
	crypto.subtle.digest("SHA-256", new TextEncoder().encode(val)).then(h => {
		const hexes = [],
			view = new DataView(h);
		for (let i = 0; i < view.byteLength; i += 4) hexes.push(("00000000" + view.getUint32(i).toString(16)).slice(-8));
		return hexes.join("");
	});

export const formatCardNumber = (iban?: string | null) => {
	if (iban) {
		const numbers = [];
		for (let i = 0; i < iban.length; i += 4) {
			numbers.push(iban.substr(i, 4));
		}

		let res = numbers.join(" ");

		if (res.length > 10) {
			res = res.substring(0, 7) + " ... " + res.substring(res.length - 4);
		}

		return res;
	}
	return "";
};
